export const LOAN_DEFAULT_FILTER = {
    DEFAULT_LOAN_APPLICATION_TYPE: {id: '', value: 'TODOS', payload: ''},
    DEFAULT_LOAN_TARGET: {id: '', value: 'TODOS', payload: ''},
    DEFAULT_LOAN_FINANCIAL_TYPE: {id: '', value: 'TODOS', payload: ''}
};

export const POS_FROM_WIZARD_TYPE = 'END_USER_ONLINE';

export const CHANGE_STATUS_LOG = {
    CHANGE_DATE_STATUS: 'Fecha cambio de estado',
    STATUS: 'Estado',
    AUTHORIZED_AMOUNT: 'Monto autorizado',
    REQUESTED_AMOUNT: 'Monto solicitado',
    OBSERVATIONS: 'Observaciones',
    PROMOTION: 'Promoción',
    RESULTS_VALIDATIONS_PHASES: 'Resultado de las validaciones en fases (checks)',
    VALIDATIONS_PHASES: 'Validación en fases',
    CHECK: 'Check',
    TYPING: 'Tipificación',
    RESULTS_VALIDATIONS_DOCUMENTS: 'Resultado de las validaciones en documentos',
    RESULTS_OTHERS_VALIDATIONS: 'Resultados de otras validaciones',
};

export const FILES_SECTION = {
    UPLOAD_FILES_TITLE: 'Archivos Adjuntos',
    UPLOAD_FILES_LABEL_1: '1. Selecciona el tipo de documento que vas a adjuntar.',
    UPLOAD_FILES_LABEL_2: '2. Adjunta los archivos que forman parte del tipo del documento seleccionado.',
    UPLOAD_DOCUMENT_TYPE_LABEL: 'Tipo de documento',
    UPLOAD_FILES_INFO_2: 'Arrastra a esta zona los PDF o imágenes  en formato JPG,' +
        ' PNG o selecciona los archivos. Peso máximo 10Mb.',
    UPLOAD_FILES_SELECT_LABEL: 'seleccionar archivo',
    VERSION_TITLE: 'Versiones anteriores',
    CREATE_VERSION_LABEL: 'Crear nueva versión',
    CREATE_VERSION_LABEL_2: 'Nueva versión',
    CANCEL_LABEL: 'Cancelar',
    DELETE_LABEL: 'Eliminar',
    UPLOAD_FILE_LABEL: 'Subir Archivos',
    REPEATED_FILE_MESSAGE: 'Archivo repetido',
    REQUIRED_FILE_MESSAGE: 'Selecciona al menos un archivo',
    REQUIRED_DOCUMENT_TYPE_MESSAGE: 'Selecciona el tipo de documento',
    ERROR_UPLOADING_FILES_MESSAGE: 'Uno o varios archivos no se guardaron correctamente',
    ERROR_DUPLICATE_FILES_MESSAGE: 'Uno o varios archivos no se guardaron correctamente ya que tienen el nombre repetido',
    ERROR_DELETING_FILE_MESSAGE: 'El archivo seleccionado no se eliminó correctamente',
    MODAL_FORM_TYPE: 'MODAL_FORM_TYPE',
    SIDEBAR_FORM_TYPE: 'SIDEBAR_FORM_TYPE',
    LIST_ATTACHMENT_FORM_TYPE: 'LIST_ATTACHMENT_FORM_TYPE',
    PDF_GENERATED_TITLE: '¡PDF generado con éxito!',
    PDF_GENERATED_DESCRIPTION: 'El documento generado se guardó en la sección de Adjuntos',
    ACCOUNT: 'Cuenta',
    CANT_UPLOAD_MORE_FILES_INFO: 'No puede subir otro archivo del tipo seleccionado, si desea hacerlo, ' +
        'por favor primero elimine el archivo existente',
};
export const BUREAU_INFORMATION_SECTION = {
    IS_ELIGIBLE: 'El usuario consultado PASÓ Buró por Motorfy',
    IS_NOT_ELIGIBLE: 'El usuario consultado NO PASÓ Buró por Motorfy',
    HAS_ERROR: 'La consulta de Buró por Motorfy respondió ERROR'
};
export const BUREAU_INFORMATION_SECTION_COPPEL = {
    IS_ELIGIBLE: 'El usuario consultado PASÓ Buró por Coppel',
    IS_NOT_ELIGIBLE: 'El usuario consultado NO PASÓ Buró por Coppel',
    HAS_ERROR: 'La consulta de Buró por Coppel respondió ERROR'
};

export const CONTINUE_LOAN_APPLICATION = {
    SUCCESS_MESSAGE: 'El correo se ha enviado exitosamente',
    FAILURE_MESSAGE: 'Se produjo un error al intentar enviar el correo'
};

export const SEND_LOAN_APPLICATION = {
    SUCCESS_MESSAGE: 'La solicitud de crédito se ha enviado exitosamente a Crédito Real',
    FAILURE_MESSAGE: 'Se produjo un error al intentar enviar solicitud de crédito'
};

export const LOAN_APPLICATION = {
    HOUSE_HOLD: 'Arraigo',
};

export const PIPEFY_CONSTANTS = {
    UPDATE_PIPEFY_TITLE: 'Actualizar en Pipefy'
};

export const PIPEFY_MESSAGE_ERRORS = {
    TC_INCOMPLETE: 'Para actualizar pipefy es necesario que la solicitud este completa.'
};

export const CLOSING_BANK_OPTIONS = [{id: 'A', value: 'Aprobado'}, {id: 'R', value: 'Rechazado'}, {id: 'SP', value: 'Sin Proceso'}];
export const CLOSING_BANK_NAMES = {
    coppel: 'COPPEL',
    creditas: 'CREDITAS',
    rapidauto: 'RAPIDAUTO',
}
